import { library } from '@fortawesome/fontawesome-svg-core'
import { faLocationPin, faPhoneAlt, faCalendarAlt, faEnvelope, faClockFour, faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp, faInstagram, faFacebookF, faYoutube, faLinkedin } from '@fortawesome/free-brands-svg-icons'

  library.add(faLocationPin, faPhoneAlt, faCalendarAlt, faEnvelope, faClockFour, faArrowDown, faWhatsapp, faInstagram, faFacebookF, faYoutube, faLinkedin)